import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const rs = [
  {
    path: '/',
    name: 'index',
    component: () => import('./views/index/Index.vue')
  },
  // {
  //   path: '/test',
  //   component: () => import('./views/TestSwiper.vue')
  // },
  {
    path: '/generalization',
    name: 'generalization',
    component: () => import('./views/Generalization/index.vue')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    component: () => import('./views/Dynamic/index.vue')
  },
  {
    path: '/newsdetails/:id',
    name: 'newsdetails',
    component: () => import('./views/NewsDetails.vue')
  },
  // {
  //   path: '/wonderful/:type',
  //   name: 'wonderful',
  //   component: () => import('./views/Wonderful/index.vue')
  // },
  {
    path: '/industry/plan',
    name: 'industry',
    component: () => import('./views/Industry/index.vue')
  },
  {
    path: '/industry/partner',
    name: 'partner',
    component: () => import('./views/Industry/partner.vue')
  },
  {
    path: '/industry/cooperation',
    name: 'cooperation',
    component: () => import('./views/Industry/cooperation.vue')
  },
  {
    path: '/contact/us',
    name: 'contactUs',
    component: () => import('./views/Contact/ContactUs.vue')
  },
  // {
  //   path: '/contact/sign',
  //   name: 'sign',
  //   component: () => import('./views/Contact/sign.vue')
  // },
  {
    path: '/article',
    name: 'article',
    component: () => import('./views/Article/index.vue')
  },
  {
    path: '/industry/detail',
    name: 'industryDetail',
    component: () => import('./views/Industry/detail.vue')
  },
  {
    path: '/shop/index',
    name: 'shopIndex',
    component: () => import('./views/Shop/index.vue')
  },
  {
    path: '/shop/detail/:id',
    name: 'goodsDetail',
    component: () => import('./views/Shop/detail.vue')
  },
  // {
  //   path: '/case',
  //   name: 'case',
  //   component: () => import('./views/Case.vue')
  // },
  // {
  //   path: '/casedetails/:id',
  //   name: 'casedetails',
  //   component: () => import('./views/CaseDetails.vue')
  // },
  // {
  //   path: '/goin',
  //   name: 'goin',
  //   component: () => import('./views/GoIn.vue')
  // },
  // {
  //   path: '/download',
  //   name: 'download',
  //   component: () => import('./views/Download.vue')
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('./views/Login.vue')
  // },
  // {
  //   path: '/admin',
  //   name: 'admin',
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: () => import('./views/Admin.vue'),
  //   children: [{
  //       path: '/admin/user',
  //       name: 'user',
  //       component: () => import('./views/Admin/User.vue')
  //     },
  //     {
  //       path: '/admin/news',
  //       name: 'new',
  //       component: () => import('./views/Admin/News.vue')
  //     },
  //     {
  //       path: '/admin/cases',
  //       name: 'cases',
  //       component: () => import('./views/Admin/Cases.vue')
  //     },
  //     {
  //       path: '/admin/team',
  //       name: 'team',
  //       component: () => import('./views/Admin/Team.vue')
  //     },
  //     {
  //       path: '/admin/course',
  //       name: 'course',
  //       component: () => import('./views/Admin/Course.vue')
  //     },
  //     {
  //       path: '/admin/enterprise',
  //       name: 'enterprise',
  //       component: () => import('./views/Admin/Enterprise.vue')
  //     },
  //     {
  //       path: '/admin/honor',
  //       name: 'honor',
  //       component: () => import('./views/Admin/Honor.vue')
  //     },
  //     {
  //       path: '/admin/dictionary',
  //       name: 'dictionary',
  //       component: () => import('./views/Admin/Dictionary.vue')
  //     },
  //     {
  //       path: '/admin/page',
  //       name: 'page',
  //       component: () => import('./views/Admin/Page.vue')
  //     }
  //   ]
  // },
  {
    path: '/404',
    component: () => import('./views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

let routes = new Router({
  routes: rs,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 判断是否需要登录权限 以及是否登录
routes.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default routes